'use strict';

const propTypes = require('prop-types');
const React = require( 'react' );
const { string, oneOfType, object } = propTypes;
const createReactClass = require('create-react-class');

const Modal = createReactClass({

  propTypes: {
    id: string.isRequired,
    heading: string,
    lead: string,
    content: oneOfType([ string, object ])
  },

  render( ) {
    const { id, heading, lead, content } = this.props;
    return (
        <div role="dialog" aria-labelledby={ id + 'Heading' } className="modal fade" id={ id }>
          <div className="modal-dialog">
            <div className="modal-content">
              { (heading || lead) && <div className="modal-header">
                <button ref={ ( c ) => this._modalCloseButton = c } className="close" data-hxtrack-name="close_modal" data-dismiss="modal" type="button" >×</button>
                { heading && (<h4 className="modal-title" id={ id + 'Heading' }>{heading}</h4>) }
                { lead && (<p className="lead">{lead}</p>) }
              </div> }
              { content && typeof content === 'object' && (
                <div className="modal-body">{ content }</div>
              )}
              { content && typeof content !== 'object' && (
                <div className="modal-body" dangerouslySetInnerHTML={{ __html: content }} />
              )}
            </div>
          </div>
        </div>
    );
  }

});

module.exports = Modal;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/modal.jsx